export default __webpack_public_path__ + "static/footer-2e65be1dd3eb50dffb6cf6e6059702c0.png";